import { render, staticRenderFns } from "./followup-card.vue?vue&type=template&id=1804ebf6&scoped=true"
import script from "./followup-card.vue?vue&type=script&lang=js"
export * from "./followup-card.vue?vue&type=script&lang=js"
import style0 from "./followup-card.vue?vue&type=style&index=0&id=1804ebf6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1804ebf6",
  null
  
)

export default component.exports